// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"e744e1fd0608b10863e9","358":"ccafcb78e5ddde476ff6"}[chunkId] + ".js";
};